import { useParams } from 'next/navigation';
import { useCarrierList } from './useCarrierList';

export function useCarrier() {
  const params = useParams();
  const carrierSlug = params?.carrierSlug;
  const { carrierList, carrierListLoading } = useCarrierList();

  return {
    carrier: carrierList?.find((c) => c.slug === carrierSlug),
    carrierLoading: carrierListLoading,
  };
}
